export default {
      id: "nav-truck-usage",
      viewBox: "0 0 26 18",
      url: __webpack_public_path__ + "icons.svg#nav-truck",
      toString: function () {
        return this.url;
      }
    }